module.exports = __webpack_public_path__ + "e3b17009ede3a294fc12cdbe7f1ba216.png";